import { render, staticRenderFns } from "./evaluationSetting.vue?vue&type=template&id=2ca3ab97&scoped=true&"
import script from "./evaluationSetting.vue?vue&type=script&lang=js&"
export * from "./evaluationSetting.vue?vue&type=script&lang=js&"
import style0 from "./evaluationSetting.vue?vue&type=style&index=0&id=2ca3ab97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca3ab97",
  null
  
)

export default component.exports